import { Chip, Tooltip } from '@mui/material';
import { useMemo } from 'react';
import { useDeliveryContainerReserveesStyles } from './delivery-container-reservees-chip.styles';

export interface DeliveryContainerReserveeChipProps {
  labels: string[];
  // Full, untruncated names shown in the hover tooltip. Falls back to `labels` when omitted.
  tooltipLabels?: string[];
  minimised?: boolean;
}

export function DeliveryContainerReserveeChip({
  labels,
  tooltipLabels,
  minimised
}: DeliveryContainerReserveeChipProps) {
  const classes = useDeliveryContainerReserveesStyles();
  const displayLabel = useMemo(() => {
    if (labels.length === 0) {
      return null;
    }
    if (labels.length > 1) {
      return 'Multiple';
    }

    return labels[0];
  }, [labels]);

  const tooltipTitle = useMemo(() => {
    const names = tooltipLabels?.length ? tooltipLabels : labels;
    if (names.length === 0) {
      return '';
    }
    if (names.length === 1) {
      return names[0];
    }

    return (
      <>
        {names.map((name, index) => (
          <div key={`${name}-${index}`}>{name}</div>
        ))}
      </>
    );
  }, [labels, tooltipLabels]);

  if (!displayLabel) {
    return null;
  }

  return (
    <Tooltip title={tooltipTitle} arrow classes={{ tooltip: classes.tooltip }}>
      <Chip
        className={`${classes.root} ${minimised ? classes.minimised : ''}`}
        classes={{
          label: `${classes.label} ${minimised ? classes.minimisedLabel : ''}`
        }}
        label={displayLabel}
        size="small"
      />
    </Tooltip>
  );
}
